export default __webpack_public_path__ + "static/media/img_truck.c48c1aa0.svg";